import Button from "components/Button/Button";
import { lang } from "constant/lang";
import React from "react";
import { AiOutlineCalendar, AiOutlineEnvironment } from "react-icons/ai";
import { Link } from "react-router-dom";

const EventCard = ({ eventName, className }) => {
  const event = lang.events?.[eventName];

  return (
    <div className={`flex flex-col gap-4 ${className}`}>
      <div className="flex gap-4 md:gap-6">
        <img
          src={event?.icon}
          alt="event"
          className="w-[108px] h-[108px] md:w-[146px] md:h-[146px]"
        />
        <div className="flex flex-col gap-1 md:gap-2">
          <div className="font-yesevaOne text-wce-pink-light md:text-2xl">
            {event?.title}
          </div>
          <div className="flex gap-2">
            <AiOutlineCalendar className="text-wce-neutral-1 w-4 h-4 md:w-5 md:h-5" />
            <div className="text-wce-neutral-1 text-xs md:text-base">
              {event?.date}
            </div>
          </div>
          <div className="flex gap-2">
            <AiOutlineEnvironment className="text-wce-neutral-1 w-4 h-4 md:w-5 md:h-5" />
            <div className="text-wce-neutral-1 text-xs md:text-base">
              {event?.location}
            </div>
          </div>
          <div>
            {event?.show ? (
              <Link to={event?.link}>
                <Button
                  color="danger"
                  size="large"
                  rounded
                  className={"w-[160px]"}
                >
                  Learn More
                </Button>
              </Link>
            ) : (
              <Button
                color="danger"
                size="large"
                rounded
                className={"w-[160px]"}
                disabled={true}
              >
                Coming Soon!
              </Button>
            )}
          </div>
        </div>
      </div>
      <div className="text-wce-neutral-1">{event?.description}</div>
    </div>
  );
};

export default EventCard;
